import Shader from '../../shader'
import {simpleShader, clamp, splineInterpolate} from '../../util'
import * as store from '../../store'

/**
 * @filter      Curves
 * @description A powerful mapping tool that transforms the colors in the image
 *              by an arbitrary function. The function is interpolated between
 *              a set of 2D points using splines. The curves filter can take
 *              either one or three arguments which will apply the mapping to
 *              either luminance or RGB values, respectively.
 * @param red   A list of points that define the function for the red channel.
 *              Each point is a list of two values: the value before the mapping
 *              and the value after the mapping, both in the range 0 to 1. For
 *              example, [[0,1], [1,0]] would invert the red channel while
 *              [[0,0], [1,1]] would leave the red channel unchanged. If green
 *              and blue are omitted then this argument also applies to the
 *              green and blue channels.
 * @param green (optional) A list of points that define the function for the green
 *              channel (just like for red).
 * @param blue  (optional) A list of points that define the function for the blue
 *              channel (just like for red).
 */
export default function(red, green, blue) {
  var gl = store.get('gl')
  // Create the ramp texture
  red = splineInterpolate(red);
  if (arguments.length == 1) {
    green = blue = red;
  } else {
    green = splineInterpolate(green);
    blue = splineInterpolate(blue);
  }
  var array = [];
  for (var i = 0; i < 256; i++) {
    array.splice(array.length, 0, red[i], green[i], blue[i], 255);
  }
  this._.extraTexture.initFromBytes(256, 1, array);
  this._.extraTexture.use(1);

  gl.curves = gl.curves || new Shader(null, '\
    uniform sampler2D texture;\
    uniform sampler2D map;\
    varying vec2 texCoord;\
    void main() {\
      vec4 color = texture2D(texture, texCoord);\
      color.r = texture2D(map, vec2(color.r)).r;\
      color.g = texture2D(map, vec2(color.g)).g;\
      color.b = texture2D(map, vec2(color.b)).b;\
      gl_FragColor = color;\
    }\
  ');

  gl.curves.textures({
    map: 1
  });
  simpleShader.call(this, gl.curves, {});

  return this;
}



// WEBPACK FOOTER //
// ./src/filters/adjust/curves.js